// extracted by mini-css-extract-plugin
export default {"item":"ArtistSinger_item__RTK4o"};